import { on } from 'delegated-events';

/*
===================================================================
Tracking
===================================================================
*/
export default (function () {
  return {
    init() {
      on('click', '.generic-track', (e) => {
        this.push(e.currentTarget);
      });
    },
    pushEvent(cat, action, label, value) {
      if (!window.console) window.console = { log() { } };
      console.log('track event:', cat, action, label, value);

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          eventCategory: cat, eventAction: action, eventLabel: label, eventValue: value, event: 'eventTracking',
        });
      }
    },
    push(tag) {
      if (!window.console) window.console = { log() { } };

      if (typeof dataLayer === 'undefined') {
        console.log('Data Layer is not defined');
        return;
      }

      const link = tag;
      if (link.getAttribute('data-ga-category') !== '' && link.getAttribute('data-ga-category') !== undefined) {
        const cat = link.getAttribute('data-ga-category');
        const action = link.getAttribute('data-ga-action');
        const label = link.getAttribute('data-ga-label');
        const value = link.getAttribute('data-ga-value');
        console.log('track event:', cat, action, label, value);
        dataLayer.push({
          eventCategory: cat,
          eventAction: action,
          eventLabel: label,
          eventValue: value,
          event: 'eventTracking',
        });
      } else {
        const cat = link.closest('[data-ga-category]').getAttribute('data-ga-category');
        const action = 'click';
        let label;
        const value = link.getAttribute('data-ga-value') || null;
        if (link.getAttribute('data-ga-label') !== '' && link.getAttribute('data-ga-label') !== undefined) {
          label = link.getAttribute('data-ga-label');
        } else {
          label = link.innerText;
        }
        console.log('track event:', cat, action, label, value);
        dataLayer.push({
          eventCategory: cat, eventAction: action, eventLabel: label, eventValue: value, event: 'eventTracking',
        });
      }
    },
  };
}());
